<template>
  <!-- 关于我们 -->
  <div class="About">
    <div class="headerbg flex-all-center">
      <div class="headerlayout">
        <p class="header-text1">{{ $t("about.title1") }}</p>
        <p class="header-text2">{{ $t("about.title2") }}</p>
      </div>
    </div>

    <!-- 内容 -->
    <div class="main">
      <div class="maincontent">
        <!-- 第一段 -->
        <div class="textlayout">
          <div class="text">
            <p class="textcontent-en" v-if="isEn">{{ expanded1 ? fullText1 : truncatedText1 }}</p>
            <p class="textcontent-cn" v-else>{{ expanded1 ? fullText1 : truncatedText1 }}</p>
            <button class="About_button" @click="toggleSection1">{{ expanded1 ? $t("about.collapsee") : $t("about.readMore") }}</button>
          </div>
          <img class="img1" src="../../assets/images/About_pic1.png" />
        </div>

        <div class="normal-text textlayout">
          <img class="img2" src="../../assets/images/About_pic2.png" />
          <div class="text">
            <p class="textcontent-en" v-if="isEn">{{ expanded2 ? fullText2 : truncatedText2 }}</p>
            <p class="textcontent-cn" v-else>{{ expanded2 ? fullText2 : truncatedText2 }}</p>
            <button class="About_button" @click="toggleSection2">
              {{ expanded2 ? $t("about.collapsee") : $t("about.readMore") }}
            </button>
          </div>
        </div>

        <div class="mobile-text textlayout">
          <div class="text">
            <p class="textcontent-en" v-if="isEn">{{ expanded2 ? fullText2 : truncatedText2 }}</p>
            <p class="textcontent-cn" v-else>{{ expanded2 ? fullText2 : truncatedText2 }}</p>
            <button class="About_button" @click="toggleSection2">
              {{ expanded2 ? $t("about.collapsee") : $t("about.readMore") }}
            </button>
          </div>
          <img class="img2" src="../../assets/images/About_pic2.png" />
        </div>

      </div>
    </div>
    <div class="footer"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "About",
  computed: {
    ...mapState({
      isEn: (state) => state.isEn,
    }),
  },
  data() {
    return {
      expanded1: false,
      fullText1: this.$t("about.fullText1"),
      truncatedText1: this.$t("about.truncatedText1"),
      expanded2: false,
      fullText2: this.$t("about.fullText2"),
      truncatedText2: this.$t("about.truncatedText2"),

      
    };
  },
    created() {
      
  },
  methods: {
    toggleSection1() {
      this.expanded1 = !this.expanded1; // 切换第一部分文字的状态
    },
    toggleSection2() {
      this.expanded2 = !this.expanded2; // 切换第二部分文字的状态
    },
  },
  watch: {
    "$i18n.locale"() {

      this.fullText1 = this.$t("about.fullText1");
      this.truncatedText1 = this.$t("about.truncatedText1");
      this.fullText2 = this.$t("about.fullText2");
      this.truncatedText2 = this.$t("about.truncatedText2");
    },
  },
};
</script>

<style lang="scss" scoped>

.About {
  color: #000;
  width: 100%;

  .headerbg {
    width: 100%;
    height: 400px;
    background: #000;
    
    .headerlayout {
      width: 60%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-family: "OPPO-L";

    .header-text1 {
      font-size: 42px;
      color: #fff;
      text-align: left;
      }

    .header-text2 {
      margin-top: 60px;
      font-size: 18px;
      color: #fff;
      text-align: center;
      margin-left: 174px;
     }
    }
  }

  .main {
    display: flex;
    justify-content: center;

    .maincontent {
      max-width: 1200px;
      color: #606266;
      font-family: "OPPO-R";
      font-size: 17px;
      line-height: 27px;
      margin-top: 17px;
      width: 100%;

      p {
        margin-top: 17px;
      }

      .text {
        width: 510px;
        .textcontent-cn{
          text-indent: 34px;
          text-align:justify;

        }
        .textcontent-en{
          text-indent: 34px;
          text-align: justify;
        }
      }

      .textlayout {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .About_button {
          font-family: "OPPO-B";
          font-size: 15px;
          background-color: #fff;
          color: #570a0b;
          border: none;
          transition: filter 0.3s ease;
        }

        .img1 {
          width: auto;
          height: 345px;
          margin-top: 80px;
          margin-bottom: 0px;

        }

        .img2 {
          width: auto;
          height: 345px;
          margin-top: 80px;
        }

      }
      .normal-text{
        display: flex;
      }
      .mobile-text{
        display: none;
      }
    }
  }
  .footer {
  margin-top: 120px;
  }
}



@media (max-width: 768px) {
.About {
  color: #000;
  width: 100%;

  .headerbg {
    width: 100%;
    height: 400px;
    background: #000;
    
    .headerlayout {
      width: 90%;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      justify-content: center;
      font-family: "OPPO-L";

    .header-text1 {
      font-size: 42px;
      color: #fff;
      text-align: left;
      }

    .header-text2 {
      font-size: 18px;
      color: #fff;
      text-align: left;
      margin-left: 0px;
     }
    }
  }

  .main {

    .maincontent {
      color: #606266;
      font-family: "OPPO-R";
      font-size: 17px;
      line-height: 27px;
      width: 90%;
      text-align: center;
      align-items: center;

      .textlayout {
        display: flex;
        flex-direction: column;
    
        .text {
          width: 100%;

          .textcontent-cn{
            text-indent: 34px;
            text-align:justify;

          }
          .textcontent-en{
            text-indent: 0px;
            text-align: start;
          }
        }

        p {
          margin-top: 17px;
        }

        .About_button {
            
            font-family: "OPPO-B";
            font-size: 15px;
            background-color: #fff;
            color: #570a0b;
            border: none;
            transition: filter 0.3s ease;
          }

          .img1 {
            width: 90%;
            height: auto;
            margin-top: 40px;
            margin-bottom: 40px;
          }

          .img2 {
            width: 90%;
            height: auto;
            margin-top: 40px;
          }
      }
      .normal-text{
        display: none;
      }
      .mobile-text{
        display: flex;
      }
    }
  }
  .footer {
  margin-top: 40px;
  }
}
}
</style>
